import React from "react";

import { Fade } from "react-reveal";

import {
  ReliabilityAndAuthenticitySVG,
  WorkplaceSafetySVG,
  LackOfDigitalSVG,
  CommunicationChallengesSVG,
  LegalAndRegulatorySVG,
  EmployeeWellSVG,
} from "../../../../assets/svgs";

import "./styles.css";

const challenges = [
  {
    icon: <WorkplaceSafetySVG />,
    title: "Limited staff capacity",
    copy: "Small teams are often responsible for intake, outreach, documentation, response coordination, and grant reporting at the same time.",
  },
  {
    icon: <LackOfDigitalSVG />,
    title: "Large service areas",
    copy: "Programs may cover broad geography, remote communities, and field-based work where timely context can be hard to collect.",
  },
  {
    icon: <CommunicationChallengesSVG />,
    title: "Centralized reporting needs",
    copy: "Reports, calls, follow-ups, and safety concerns can become fragmented when teams rely on email, spreadsheets, phone notes, or separate systems.",
  },
  {
    icon: <LegalAndRegulatorySVG />,
    title: "Multi-partner coordination",
    copy: "Victim services, law enforcement, schools, healthcare, Tribal partners, and local government may all need appropriate visibility into different parts of the work.",
  },
  {
    icon: <ReliabilityAndAuthenticitySVG />,
    title: "Better documentation",
    copy: "Programs need clear records that support case coordination, internal accountability, activity tracking, outcome reporting, and future planning.",
  },
  {
    icon: <EmployeeWellSVG />,
    title: "Timely response visibility",
    copy: "Teams need to know when a concern is submitted, who has appropriate awareness, and what follow-up is happening across distance or after hours.",
  },
];

const Problem = () => {
  return (
    <Fade bottom>
      <section id="problem" className="rural_problem_container">
        <div className="rural_section_header">
          <span className="h2-sb text-primary">Program challenges</span>
          <h1 className="h1-b text-white">
            Challenges rural victim-service governments face
          </h1>
          <p className="h3-m text-white">
            Rural governments and victim service organizations often need
            practical workflows that reduce administrative load while improving
            awareness, coordination, and documentation across a wide service
            area.
          </p>
        </div>
        <div className="rural_challenge_grid">
          {challenges.map((challenge) => (
            <article className="rural_challenge_card" key={challenge.title}>
              <div className="rural_challenge_icon">{challenge.icon}</div>
              <h2 className="h2-sb text-white">{challenge.title}</h2>
              <p className="h4-r text-white">{challenge.copy}</p>
            </article>
          ))}
        </div>
      </section>
    </Fade>
  );
};

export default Problem;
